"use client";

import { useState } from "react";

export default function ShareButtons({ url, title }: { url: string; title: string }) {
  const [copied, setCopied] = useState(false);
  const encUrl = encodeURIComponent(url);
  const encTitle = encodeURIComponent(title);

  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // ignore
    }
  }

  async function nativeShare() {
    if ("share" in navigator) {
      try {
        await (navigator as Navigator & { share: (d: ShareData) => Promise<void> }).share({
          title,
          url,
        });
      } catch {
        // user cancelled or unsupported
      }
    } else {
      void copy();
    }
  }

  return (
    <div className="flex items-center gap-1.5">
      <button
        type="button"
        onClick={nativeShare}
        title="Share"
        className="text-xs px-2.5 py-1 border border-neutral-300 rounded-lg hover:bg-neutral-50 inline-flex items-center gap-1"
      >
        🔗 Share
      </button>
      <a
        href={`https://x.com/intent/tweet?text=${encTitle}&url=${encUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        title="Share on X"
        className="text-xs px-2 py-1 border border-neutral-300 rounded-lg hover:bg-neutral-50"
      >
        𝕏
      </a>
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        title="Share on Facebook"
        className="text-xs px-2 py-1 border border-neutral-300 rounded-lg hover:bg-neutral-50"
      >
        f
      </a>
      <a
        href={`https://wa.me/?text=${encTitle}%20${encUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        title="Share on WhatsApp"
        className="text-xs px-2 py-1 border border-neutral-300 rounded-lg hover:bg-neutral-50"
      >
        📱
      </a>
      <button
        type="button"
        onClick={copy}
        title="Copy link"
        className="text-xs px-2 py-1 border border-neutral-300 rounded-lg hover:bg-neutral-50"
      >
        {copied ? "✓ Copied" : "📋"}
      </button>
    </div>
  );
}
